import {useQueryClient} from '@tanstack/react-query'
import {Moment} from 'moment-timezone'

import {peakLoadWindowsQueryOptions} from './usePeakLoadWindowsQuery'

type MomentRange = [start: Moment, end: Moment]

export const usePrefetchPeakLoadWindows = (plantId: string, timeFrame: MomentRange) => {
  const queryClient = useQueryClient()
  void queryClient.prefetchQuery(peakLoadWindowsQueryOptions(plantId, timeFrame))
}
